import { orgSelectors } from 'ducks/orgs'

import { useSelector } from 'react-redux'
import RegisterLink from '../RegisterLink'
import type { PriceDetailProps } from './PriceDetail'
import PriceDetail from './PriceDetail'

const ProductPrice = (props: PriceDetailProps) => {
  const enabledDistributors = useSelector(orgSelectors.getEnabledHardwareSuppliers)
  const selectedDistributor = useSelector(orgSelectors.getSelectedHardwareSupplier)
  if (selectedDistributor === 'city_plumbing') {
    return <PriceDetail {...props} isShop3={false} />
  } else if (selectedDistributor === 'outlet') {
    if (enabledDistributors?.includes('outlet')) {
      return <PriceDetail {...props} isShop3={false} />
    } else {
      return <RegisterLink />
    }
  } else {
    return null
  }
}

export default ProductPrice
